var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4251 1.63293L15.5664 13.7703L2.45836 15.723C0.107706 16.0713 -0.834348 19.0323 0.870321 20.7283L10.3537 30.1705L8.11068 43.5089C7.70694 45.9198 10.1922 47.7258 12.2737 46.5982L24 40.3003L35.7263 46.5982C37.8078 47.7166 40.2931 45.9198 39.8893 43.5089L37.6463 30.1705L47.1297 20.7283C48.8343 19.0323 47.8923 16.0713 45.5416 15.723L32.4336 13.7703L26.5749 1.63293C25.5252 -0.530537 22.4837 -0.558039 21.4251 1.63293Z"
  })));
};
export default SvgStar;